// A supplier's delivery, in words (Oct 2026: sending orders). The dates and cut-offs come from
// the server (`buying.next_deliveries`), on the venue's clock.

const DAY = { weekday: 'short', day: 'numeric', month: 'short' };

/** "Tue 27 Oct" for "2026-10-27". */
export function deliveryWords(iso) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString('en-GB', DAY);
}

const sameDay = (a, b) => a.toDateString() === b.toDateString();

/** "order by 14:00 today · 2h 40m left", "order by 16:00 tomorrow", "order by 14:00 Thu 29 Oct". */
export function cutOffWords(orderBy, now = new Date()) {
  const t = new Date(orderBy);
  if (Number.isNaN(t.getTime())) return '';
  const hhmm = t.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const day = sameDay(t, now) ? 'today' : sameDay(t, tomorrow) ? 'tomorrow' : t.toLocaleDateString('en-GB', DAY);
  const mins = Math.floor((t - now) / 60000);
  const left = sameDay(t, now) && mins > 0 ? ` · ${mins >= 60 ? `${Math.floor(mins / 60)}h ${mins % 60}m` : `${mins}m`} left` : '';
  return `order by ${hhmm} ${day}${left}`;
}
